import { createSlice } from "@reduxjs/toolkit";
import { getListService } from "../../api/serviceProject/service";

// giá trị khởi tạo của state
const initialState = {
  listService: [],
  isLoadService: false,
  currentPage: 1,
  pageSize: 10,
  hasFetchedData: false,
  error: null,
  
};

const servicesSlice = createSlice({
  name: "services", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setHasFetchedData: (state, action) => {
      state.hasFetchedData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListService.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadService = true;
        state.error = null;
      })
      .addCase(getListService.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadService = false;
        state.listService = action.payload.data || [];

        state.isLoadService = false;
        state.hasFetchedData = true;
      })
      .addCase(getListService.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadService = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setHasFetchedData } = servicesSlice.actions;
export default servicesSlice.reducer;
